import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CookieModule } from 'ngx-cookie';

import { MegaFooterSharedComponent } from './mega.footer/mega.footer.component';

import { IconSharedModule } from './../../atoms/icon/icon.module';
import { FooterNavSharedModule } from './../../molecules/footer.nav/footer.nav.module';

@NgModule({
    declarations: [
        MegaFooterSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        FooterNavSharedModule,
        CookieModule.forRoot()
    ],
    exports: [
        MegaFooterSharedComponent
    ]
})

export class FooterSharedModule {}
